// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BurgerIcon from '../../_common/BurgerIcon';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import MenuList from './MenuList';

const Wrapper = styled.div`
    height: 100%;
    width: ${({ open }) => open ? '50%' : 0};
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.secondary};
    overflow-x: hidden;
    transition: all 600ms cubic-bezier(.62, .04, .3, 1.56);
    transition-delay: 100ms;
`
const InnerWrap = styled.div`
    height: 100%;
    width: ${({ open }) => open ? '50%' : 0};
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.secondary}80;
    overflow-x: hidden;
    transition: all 500ms cubic-bezier(.62, .04, .3, 1.8);
    transition-delay: 50ms;
`
const Content = styled.div`
    position: relative;
    top: 15%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 30px;
`
const ScreenWrap = styled.div`
    height: 100%;
    width: 100%;
    opacity: ${({ open }) => open ? 1 : 0};
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.secondary}80;
    overflow-x: hidden;
    transition: opacity 500ms ease-in-out;

    ${({ open }) => !open && 'pointer-events: none;'}
`
const Block = styled.div`
    width: 100%;
    height: 60px;
    background-color: ${({ theme }) => theme.secondary};
    position: fixed;
    top: 0;
    z-index: 10;
`
const SmallBar = styled.div`
    width: 100%;
    height: 5px;
    background-color: ${({ theme }) => theme.tertiary};
    position: absolute;
    top: 100%;
`
const ImgWrapper = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.5s;
    box-shadow: unset;
    position: absolute;
    height: 60px;
    left: 50%;
    transform: translateX(-50%);
`
const Img = styled.img`
    height: 100%;
`

const MobileMenu = ({ children, ...props }) => {
    const {
        state: {
            active_user,
            site_config
        },
    } = useGlobalState();

    const [isOpen, setIsOpen] = useState(false);

    return (
        <Block>
            <ImgWrapper to='/'>
                <Img
                    src={site_config.logo}
                    alt='logo'
                />
            </ImgWrapper>
            <BurgerIcon updateOpenState={setIsOpen} open={isOpen} />
            <ScreenWrap open={isOpen} onClick={() => setIsOpen(false)} />
            <Wrapper open={isOpen}>
                <InnerWrap open={isOpen} />
                <Content>
                    <MenuList
                        updateOpenState={setIsOpen}
                    />
                </Content>
            </Wrapper>
            <SmallBar />
        </Block>
    );
}

export default MobileMenu;